import React from 'react';
import Modal from 'react-modal';

import CustomButton from '../button/CustomButton';
import {
  WholeWrapper,
  ModalHeader,
  ModalHeaderLines,
  ModalPrimaryText,
  ModalMain,
  ModalSecondaryText,
  ButtonsFlexWrapper,
  ButtonWrapper,
  ModalSecondaryQuestion,
} from './components';

const customStyles = {
  overlay: {
    backgroundColor: '#05000066',
    zIndex: '1111',
  },
  content: {
    zIndex: '11111',
    width: 'Calc(100% - 40px)',
    maxWidth: '588px',
    minWidth: '320px',
    height: 'fit-content',
    top: '44%',
    left: '50%',
    right: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    color: '#001212',
    borderRadius: '12px',
    border: 'none',
    padding: '0 ',
  },
};

const AreYouSureModal = ({
  modalOpen,
  closeModal,
  submitModal,
  headingText,
  contentText,
  choiceQuestion,
}) => {
  return (
    <Modal
      onRequestClose={closeModal}
      isOpen={modalOpen}
      style={customStyles}
      contentLabel="EditPersonalInfo"
      ariaHideApp={false}
    >
      <WholeWrapper>
        <ModalHeader>
          <ModalHeaderLines />
        </ModalHeader>
        <ModalMain>
          <ModalPrimaryText>{headingText}</ModalPrimaryText>
          <ModalSecondaryText>{contentText}</ModalSecondaryText>
          <ModalSecondaryQuestion>{choiceQuestion}</ModalSecondaryQuestion>
          <ButtonsFlexWrapper>
            <ButtonWrapper>
              <CustomButton
                fontSize="1.4rem"
                fontFamily="Roboto-r"
                onClick={closeModal}
                borderRadius="8px"
              >
                No
              </CustomButton>
            </ButtonWrapper>
            <ButtonWrapper>
              <CustomButton
                fontSize="1.4rem"
                fontFamily="Roboto-r"
                backgroundColor="#ffffff"
                outlined
                borderRadius="8px"
                onClick={() => {
                  submitModal();
                  closeModal();
                }}
              >
                Yes
              </CustomButton>
            </ButtonWrapper>
          </ButtonsFlexWrapper>
        </ModalMain>
      </WholeWrapper>
    </Modal>
  );
};

export default AreYouSureModal;
